export const numberOfRows = (data, pivotName) => {
  let dataSize = data && data.length;

  if (data && pivotName) {
    let pivots = new Set(data.map(item => item[pivotName]));
    let pivot_not_found = pivots.size === 1 && pivots.has(undefined);

    if (!pivot_not_found) {
      dataSize = pivots.size;
    }
  }

  return dataSize && dataSize > 0 ? dataSize : 4;
};
